import { Inject, Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { Environment } from '../../../app/types/environment.interface';
import { AddHeadersRequestPolicy } from '../../addresses-store/util';
import { ENVIRONMENT } from '../../core';
import {
  CustomerLoginNotifyDiscountOnBasketResponse,
  DiscountAPI,
  DiscountAPIOptionalParams,
  RemoveVoucherCodeResponse,
  VoucherCodeApplyResponse,
} from '../client/src';

@Injectable({
  providedIn: 'root',
})
export class DiscountService {
  protected readonly baseApi: DiscountAPI;

  constructor(@Inject(ENVIRONMENT) private env: Environment) {
    const clientParams: DiscountAPIOptionalParams = {
      baseUri: `${env.nxApi.base}/${env.nxApi.fragment.discount}`,
      endpoint: `${env.nxApi.base}/${env.nxApi.fragment.discount}`,
      additionalPolicies: [
        { policy: new AddHeadersRequestPolicy(), position: 'perCall' },
      ],
      retryOptions: {
        maxRetries: 0,
      },
    };

    this.baseApi = new DiscountAPI(clientParams);
  }

  public applyVoucherCode(basketId: string, voucherCode: string): Observable<VoucherCodeApplyResponse> {
    return from(this.baseApi.applyVoucherCode({ body: { basketId, voucherCode } }));
  }

  public removeVoucherCode(basketId: string): Observable<RemoveVoucherCodeResponse> {
    return from(this.baseApi.removeVoucherCode(basketId, {
      requestOptions: {
        customHeaders: {
          'Content-Type': 'application/json',
        },
      }
    }));
  }

  public associateCustomerWithBasket(basketId: string, openIdToken: string): Observable<CustomerLoginNotifyDiscountOnBasketResponse> {
    return from(this.baseApi.customerLoginNotifyDiscountOnBasket(basketId, openIdToken));
  }
}
